import React, { Component } from 'react';

import { Loading, SERVER_ERROR } from 'commons';
import request from '../request';

class ConfirmSignup extends Component {
  state = {
    loading: true,
    email: '',
    token: this.props.match.params.token,
    tokenExpiredOrInvalid: false,
    error: false,
    success: false
  };

  async componentDidMount() {
    try {
      const res = await request(`/session/signup/${this.state.token}`);

      this.setState({ loading: false });

      if (res.status >= 500) {
        this.setState(SERVER_ERROR);
        return;
      } else if (res.status >= 400) {
        this.setState({ tokenExpiredOrInvalid: true });
        return;
      }

      const data = await res.json();

      this.setState({ email: data.email, success: true });

      setTimeout(() => {
        if (data.action === 'success') {
          document.location.href = data.redirectUri;
        }
      }, 5000);
    } catch (error) {
      this.setState({ loading: false, ...SERVER_ERROR });
    }
  }

  renderForm() {
    if (this.state.loading) return <Loading />;
    if (this.state.success) {
      return <div className="invite">
        User <span style={{ fontWeight: 400 }}>{this.state.email}</span> has been created successfully
        <br />
        You will be automatically redirected.
      </div>
    }
    if (this.state.tokenExpiredOrInvalid) {
      return <div className="invite">The sign up link is invalid or expired.</div>;
    }
    if (this.state.error) return <div>{this.state.error}</div>;

    return <div className="invite">Please wait while we are creating your User Account...</div>;
  }

  render() {
    return (
      <div className="boxed-container">
        {this.renderForm()}
      </div>
    );
  }
}

export default ConfirmSignup;
